import { bindRequestLogic } from './utils'
import LogMailTypes from '../actionTypes/logMail'
import { logMailAPI } from '../api'

const getLogMails = bindRequestLogic({
  clientFunc: logMailAPI.getLogMails,
  type: LogMailTypes.GET_LOG_MAILS_REQUEST,
  successType: LogMailTypes.GET_LOG_MAILS_SUCCESS,
  failType: LogMailTypes.GET_LOG_MAILS_FAILED,
  isQueryParam: true,
  modelName: 'logMails'
})

export default [getLogMails]
